<template>
<banner-temp :mode="'HomeGroups'+props.item.id" v-if="props.item.items.length"/>
<section class="px-3 rounded mb-4" :style="{backgroundColor: props.item.bg_color}" v-if="props.item.items.length">
    <!-- desktop -->
    <div class="justify-content-between align-items-center py-1 rounded desktop-container">
        <div>
            <h6 :style="{color:props.item.color}" style="font-weight: 700;">{{ props.item.name }}</h6>
            <small :style="{color:props.item.color}">{{ props.item.description }}</small>
        </div>
        <button @click="wholeItems(props.item.id)" class="btn p-0"  :style="{color:props.item.color}" style="font-size: small;" >همه <i class="fa fa-arrow-circle-left"></i></button>
    </div>
    <div class="sc-1r3hge1-0 heMFVq scroll-example pb-0">
        <!-- mobile -->
        <div class="justify-content-around flex-column align-items-center pb-1 rounded mobile-container ml-1" style="width: 135px;min-width:135px !important" >
            <div>
                <h6 :style="{color:props.item.color}" style="font-weight: 700;">{{ props.item.name }}</h6>
                <small :style="{color:props.item.color}">{{ props.item.description }}</small>
            </div>
            <button @click="wholeItems(props.item.id)" class="btn p-0"  :style="{color:props.item.color}" style="font-size: small;" >همه <i class="fa fa-arrow-circle-left"></i></button>
        </div>
        <product-vue :list="props.item.items" />
    </div>
</section>
</template>
<script setup>
import ProductVue from '@/components/section/item/product.vue';
import router from '@/router';
import { defineProps } from 'vue';
import { useRoute } from 'vue-router';
import BannerTemp from '../../item/BannerTemp.vue';
let route = useRoute()
let props = defineProps(['item','whole'])
function wholeItems(id){
    router.push({name:'HomeWoleBtn',params:{id:id}})
}
</script>
<style scoped>
i{
    vertical-align: middle;
}
.mobile-container{
    display: none;
}
.desktop-container{
    display: flex;
}
section{
    padding-top: .25rem;
    padding-bottom: 1rem;
}
@media (min-width:436px) {
    .desktop-container{
        display: none;
    }
    .mobile-container{
        display: flex;
    }
    section{
        padding-top: 1rem !important;
    }
}
small{
    font-size: small;
}
</style>